module.exports = __webpack_public_path__ + "static/media/PublicIllu.86c4d394.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/PublicIllu.svg
// module id = 1138
// module chunks = 0